export default "__VITE_ASSET__BHupO3iN__"